<template>
  <div>
    <div class="gradesCCs qcFrom" v-for="(item, objindex) in obj" :key="objindex">
      <div class="gradesCCsTop">
        <p class="gradesCCsTopL">
          {{ item.Description }}({{ item.TotalScore }})
          <i v-if="item.notSelected" class="iconfont iconjingshi1" style="color: #FCAE23;"></i>
        </p>
        <div class="gradesCCsTopR">
          <el-checkbox
            v-model="item.IsSerious"
            v-if="item.SeriousScore"
            :disabled="isSubmintserious"
            @change="compentedScore(item.IsSerious, objindex)"
          >
            严重
          </el-checkbox>
          <span style="margin-left:10px">
            扣分:{{ computeItemScore(item.Score, item.SeriousScore, item.IsSerious) }}
          </span>

          <a
            href="javascript:;"
            class="el-icon-caret-bottom gradesCCsTopRA"
            v-if="!item.IsNoteShow"
            @click="item.IsNoteShow = !item.IsNoteShow"
          ></a>
          <a
            href="javascript:;"
            class="el-icon-caret-top gradesCCsTopRA"
            v-else
            @click="item.IsNoteShow = !item.IsNoteShow"
          ></a>
        </div>
      </div>
      <el-checkbox-group
        v-if="item.OptionList.length > 0"
        v-model="item.OptionGuid"
        @change="compentedScore"
        size="mini"
        :disabled="isSubmintserious || item.IsSerious"
        class="gradesSelest"
      >
        <!-- <el-radio v-for="(item,index) in item.OptionList" :key="index" :label="item.OptionGuid" @change="radioClick(objindex,index,item)">
					<template v-if="item.Remark">
						{{item.Description}}({{item.Score}}) : {{item.Remark}}
					</template>
					<template v-else>
						{{item.Description}}({{item.Score}})
					</template>
				</el-radio> -->
        <el-checkbox-button
          v-for="(items, index) in item.OptionList"
          :key="index"
          :label="items.OptionGuid"
          @change="radioClick(objindex, index, item)"
        >
          <template v-if="items.Remark">
            <el-tooltip :content="items.Remark" placement="top" popper-class="atooltip" effect="dark">
              <span>{{ items.Description }}({{ items.Score }})</span>
            </el-tooltip>
          </template>
          <template v-else>{{ items.Description }}({{ items.Score }})</template>
        </el-checkbox-button>
        <!--<el-radio-button class="btnMar" v-for="(item,index) in item.OptionList" :key="index" :label="item.Score">
					<template v-if="item.Remark">
						<el-tooltip :content="item.Remark" placement="top" popper-class="atooltip" effect="dark">
							<span>{{item.Description}}({{item.Score}})</span>
						</el-tooltip>
					</template>
					<template v-else>
						{{item.Description}}({{item.Score}})
					</template>
				</el-radio-button>-->
      </el-checkbox-group>

      <el-slider
        v-else
        v-model="item.Score"
        :max="item.TotalScore"
        @change="compentedScore"
        :disabled="isSubmintserious || item.IsSerious"
      ></el-slider>
      <div class="gradesSelest" v-if="item.IsNoteShow">
        <el-form ref="form">
          <el-form-item label="原因">
            <el-input
              :readonly="isSubmintserious"
              v-model="item.Note"
              type="textarea"
              @blur="noteBlur(item, objindex)"
              :class="item.notFilledIn ? 'bgImgSet' : ''"
              placeholder="请输入扣分原因"
            ></el-input>
            <!--<p v-else v-html="item.Note"></p>-->
          </el-form-item>
        </el-form>
      </div>
      <div class="dividingLine"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    obj: {},
  },
  computed: {
    ...Vuex.mapState("doctor", ["isSubmintserious", "doctorQCImgserious", "doctorQCReportserious", "gradeType"]),
  },
  methods: {
    ...Vuex.mapMutations("doctor", ["setScoreTotileserious"]),
    radioClick(objindex, index, item) {
      this.$emit("changeActiveNames");
      if (this.gradeType == "report") {
        let totalScore = 0; // 重置总分
        let fatherTotalScore = this.doctorQCReportserious[objindex].TotalScore;
        this.doctorQCReportserious[objindex].OptionGuid.forEach((guid) => {
          const selectedItem = this.doctorQCReportserious[objindex].OptionList.find((item) => item.OptionGuid === guid);
          if (selectedItem) {
            totalScore += selectedItem.Score;
          }
        });
        if (totalScore >= fatherTotalScore) {
          totalScore = fatherTotalScore;
        }
        this.doctorQCReportserious[objindex].OptionGuid = item.OptionGuid;
        // this.doctorQCReportserious[objindex].OptionResult = item;
        this.doctorQCReportserious[objindex].Score = totalScore;
      }
      if (this.gradeType == "img") {
        let totalScore = 0; // 重置总分
        let fatherTotalScore = this.doctorQCImgserious[objindex].TotalScore;
        this.doctorQCImgserious[objindex].OptionGuid.forEach((guid) => {
          const selectedItem = this.doctorQCImgserious[objindex].OptionList.find((item) => item.OptionGuid === guid);
          if (selectedItem) {
            totalScore += selectedItem.Score;
          }
        });
        if (totalScore >= fatherTotalScore) {
          totalScore = fatherTotalScore;
        }
        this.doctorQCImgserious[objindex].OptionGuid = item.OptionGuid;
        // this.doctorQCImgserious[objindex].OptionResult = item;
        this.doctorQCImgserious[objindex].Score = totalScore;
      }
    },
    noteBlur(item, index) {
      if (this.gradeType == "report") {
        if (item.Note != "") {
          this.doctorQCReportserious[index].notFilledIn = false;
        } else {
          if (item.Score != 0) {
            this.doctorQCReportserious[index].notFilledIn = true;
          }
        }
      }
      if (this.gradeType == "img") {
        if (item.Note != "") {
          this.doctorQCImgserious[index].notFilledIn = false;
        } else {
          if (item.Score != 0) {
            this.doctorQCImgserious[index].notFilledIn = true;
          }
        }
      }
      this.$forceUpdate();
    },
    compentedScore(isSerious, objindex) {
      if (this.gradeType == "report") {
        let reportScore = 0;
        let setReportScore = 0;
        if (isSerious === true) {
          this.doctorQCReportserious[objindex].OptionGuid = [];
        } else if (isSerious === false) {
          this.doctorQCReportserious[objindex].Score = 500;
        }
        for (let i = 0; i < this.doctorQCReportserious.length; i++) {
          if (this.doctorQCReportserious[i].Score != 500) {
            this.doctorQCReportserious[i].notSelected = false;
          }
          if (this.doctorQCReportserious[i].IsSerious) {
            reportScore += this.doctorQCReportserious[i].SeriousScore;
            this.doctorQCReportserious[i].Score = this.doctorQCReportserious[i].SeriousScore;
          } else {
            reportScore += this.doctorQCReportserious[i].Score != 500 ? this.doctorQCReportserious[i].Score : 0;
          }
          // //显示备注
          if (
            this.doctorQCReportserious[i].IsSerious ||
            (this.doctorQCReportserious[i].Score != 500 && this.doctorQCReportserious[i].Score != 0)
          ) {
            this.doctorQCReportserious[i].IsNoteShow = true;
          } else {
            this.doctorQCReportserious[i].IsNoteShow = false;
          }
        }
        setReportScore = 100 - reportScore > 0 ? 100 - reportScore : 0;
        if (setReportScore > 100) {
          setReportScore = 100;
        }
        this.setScoreTotileserious({
          type: "report",
          num: setReportScore,
        });
      }
      if (this.gradeType == "img") {
        let imgScore = 0; //扣分
        let setImgScore = 0;
        if (isSerious === true) {
          this.doctorQCImgserious[objindex].OptionGuid = [];
        } else if (isSerious === false) {
          this.doctorQCImgserious[objindex].Score = 500;
        }
        for (let i = 0; i < this.doctorQCImgserious.length; i++) {
          if (this.doctorQCImgserious[i].Score != 500) {
            this.doctorQCImgserious[i].notSelected = false;
          }

          if (this.doctorQCImgserious[i].IsSerious) {
            imgScore += this.doctorQCImgserious[i].SeriousScore;
            this.doctorQCImgserious[i].Score = this.doctorQCImgserious[i].SeriousScore;
          } else {
            imgScore += this.doctorQCImgserious[i].Score != 500 ? this.doctorQCImgserious[i].Score : 0;
          }

          //显示备注
          if (
            this.doctorQCImgserious[i].IsSerious ||
            (this.doctorQCImgserious[i].Score != 500 && this.doctorQCImgserious[i].Score != 0)
          ) {
            this.doctorQCImgserious[i].IsNoteShow = true;
          } else {
            this.doctorQCImgserious[i].IsNoteShow = false;
          }
        }
        setImgScore = 100 - imgScore > 0 ? 100 - imgScore : 0;

        if (setImgScore > 100) {
          setImgScore = 100;
        }
        this.setScoreTotileserious({
          type: "img",
          num: setImgScore,
        });
      }
    },
    computeItemScore(score, seriousScore, isSerious) {
      if (isSerious) {
        return seriousScore;
      } else {
        return score != 500 ? score : 0;
      }
    },
  },
};
</script>
